// Product Page gallery Swiper Script
window.addEventListener('load', function() {
    document.querySelector('.custom-variants-container').classList.add('show');
  });
var swiper = new Swiper(".maingalleryThumbs", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 4,
    speed: 200,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        580: {
            slidesPerView: 7,
        }
    },
    on: {
        init: function () {
            // Check if slides are overflowing
            const wrapper = document.querySelector('product-info .product--thumbnail_slider .thumbnail-slider .swiper-wrapper');
            const container = document.querySelector('product-info .product--thumbnail_slider .thumbnail-slider');

            if (!wrapper || !container) return;

            if (wrapper.scrollWidth > container.offsetWidth) {
                wrapper.style.justifyContent = '';
            } else {
                wrapper.style.justifyContent = 'center';
            }
        },
        resize: function () {
            // Recheck on resize
            const wrapper = document.querySelector('product-info .product--thumbnail_slider .thumbnail-slider .swiper-wrapper');
            const container = document.querySelector('product-info .product--thumbnail_slider .thumbnail-slider');

            if (!wrapper || !container) return;

            if (wrapper.scrollWidth > container.offsetWidth) {
                wrapper.style.justifyContent = '';
            } else {
                wrapper.style.justifyContent = 'center';
            }
        },
        // Slides change pe bhi check karen
        slideChange: function () {
            const wrapper = document.querySelector('product-info .product--thumbnail_slider .thumbnail-slider .swiper-wrapper');
            const container = document.querySelector('product-info .product--thumbnail_slider .thumbnail-slider');

            if (!wrapper || !container) return;

            if (wrapper.scrollWidth > container.offsetWidth) {
                wrapper.style.justifyContent = '';
            } else {
                wrapper.style.justifyContent = 'center';
            }
        }
    }
});

var swiper2 = new Swiper(".maingallery", {
    loop: false,
    spaceBetween: 10,
    speed: 500,
    navigation: {
        nextEl: ".maingallery-next",
        prevEl: ".maingallery-prev",
    },
    thumbs: {
        swiper: swiper,
    },
    on: {
        slideChangeTransitionEnd: function () {
            document.querySelectorAll('.maingallery .swiper-slide video').forEach((video) => {
                const slide = video.closest('.swiper-slide');
                if (slide.classList.contains('swiper-slide-active')) {
                    video.loop = true;
                    video.play().catch(() => { });
                } else {
                    video.pause();
                }
            });
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.cl-colorswatch', {
        slidesPerView: 4,
        spaceBetween: 5,
        grabCursor: true,
        navigation: {
            nextEl: '.cl-colorswatch-next',
            prevEl: '.cl-colorswatch-prev',
        },
        loop: false,
    });
});

let totalSlides = swiper2.slides.length;
document.querySelector(".total-slides").textContent = totalSlides;
document.querySelector(".current-index").textContent = swiper2.realIndex + 1;

swiper2.on('slideChange', function () {
    document.querySelector(".current-index").textContent = swiper2.realIndex + 1;
});

document.querySelector(".prev-btn").addEventListener("click", () => swiper2.slidePrev());
document.querySelector(".next-btn").addEventListener("click", () => swiper2.slideNext());

// Heel Height Swiper

document.addEventListener('DOMContentLoaded',()=>{ 
    document.querySelectorAll('.customVariantsSwiper').forEach((el,i)=>{
      new Swiper(el,{
        slidesPerView:4,
        spaceBetween:6,
        navigation:{
          nextEl:el.parentElement.querySelector('.cv-swiper-button-next'),
          prevEl:el.parentElement.querySelector('.cv-swiper-button-prev')
        },
        breakpoints:{
          0:{slidesPerView:3.5},
          768:{slidesPerView:4}
        }
      })
    })
  })

// Optional: trigger once on load

window.addEventListener('load', () => {
    setTimeout(() => {
        const activeSlide = document.querySelector('.maingallery .swiper-slide-active video');
        if (activeSlide) {
            activeSlide.loop = true;
            activeSlide.play().catch(() => { });
        }
    }, 500); // delay to ensure Swiper init
});

// Popup Zoom

// $(document).ready(function () {
//     $('product-info media-gallery .maingallery').on('click', '.swiper-slide li', function () {
//         $('product-info media-gallery').removeClass('activePopup');
//         $(this).closest('media-gallery').addClass('activePopup');
//         $('header').css('display', 'none');
//         $('body').css('overflow', 'hidden');
//     });
// });
let scrollPosition = 0;

$(document).ready(function () {
  $('product-info media-gallery .maingallery').on('click', '.swiper-slide li', function () {

    scrollPosition = window.pageYOffset;

    $('product-info media-gallery').removeClass('activePopup');
    $(this).closest('media-gallery').addClass('activePopup');

    $('header').hide();

    $('body').css({
      position: 'fixed',
      top: `-${scrollPosition}px`,
      width: '100%',
      overflow: 'hidden'
    });

  });
});

// when closing popup
function unlockBody() {
  $('body').css({
    position: '',
    top: '',
    overflow: ''
  });

  window.scrollTo(0, scrollPosition);
}

// $(document).on('click', 'product-info media-gallery.activePopup button.cl-popup--close', function () {
//     $('product-info media-gallery.activePopup .product__media img').css({
//         transform: 'scale(1) translate(0px,0px)',
//         'transform-origin': 'center center'
//     });
//     zoomLevel = 1; translateX = 0; translateY = 0;
//     $(this).closest('media-gallery').removeClass('activePopup');
//     $('header').css('display', 'block');
//     $('body').css('overflow', '');
// });
$(document).on('click', 'product-info media-gallery.activePopup button.cl-popup--close', function () {

    $('product-info media-gallery.activePopup .product__media img').css({
        transform: 'scale(1) translate(0px,0px)',
        'transform-origin': 'center center'
    });

    zoomLevel = 1;
    translateX = 0;
    translateY = 0;

    $(this).closest('media-gallery').removeClass('activePopup');
    $('header').show();

    // unlock body scroll (iPhone fix)
    $('body').css({
        position: '',
        top: '',
        width: '',
        overflow: ''
    });

    window.scrollTo(0, scrollPosition);
});

// // Zoom Script

let zoomLevel = 1;
let translateX = 0;
let translateY = 0;
let isDragging = false;
let startX, startY;

function updateTransform($img) {
    $img.css('transform', `scale(${zoomLevel}) translate(${translateX}px, ${translateY}px)`);
    $img.css('transform-origin', 'center center');
}

$('.zoom-btn').on('click', function () {
    if (window.innerWidth <= 767) return;
    if (!$('product-info media-gallery').hasClass('activePopup')) return;
    const isPlus = $(this).hasClass('plus');
    const $activeSlide = $('product-info media-gallery.activePopup .maingallery .swiper-slide-active');
    const $img = $activeSlide.find('.product__media img');
    zoomLevel += isPlus ? 0.5 : -5;
    zoomLevel = Math.max(1, Math.min(3, zoomLevel));
    if (zoomLevel === 1) { translateX = 0; translateY = 0; }
    updateTransform($img);
});

$(document).on('mousedown touchstart', '.swiper-slide-active', function (e) {
    if (window.innerWidth <= 767) return;
    if (!$('product-info media-gallery').hasClass('activePopup')) return;
    const $img = $(this).find('.product__media img');
    if (zoomLevel === 1) return;
    isDragging = true;
    startX = e.pageX || e.originalEvent.touches[0].pageX;
    startY = e.pageY || e.originalEvent.touches[0].pageY;
    $(document).on('mousemove touchmove', function (e2) {
        if (!isDragging) return;
        let currentX = e2.pageX || e2.originalEvent.touches[0].pageX;
        let currentY = e2.pageY || e2.originalEvent.touches[0].pageY;
        translateX += (currentX - startX);
        translateY += (currentY - startY);
        startX = currentX;
        startY = currentY;
        updateTransform($img);
    });
    $(document).on('mouseup touchend', function () {
        isDragging = false;
        $(document).off('mousemove touchmove mouseup touchend');
    });
});

document.querySelectorAll('.swiper-slide').forEach(el => {
    el.addEventListener('wheel', e => {
        if (window.innerWidth <= 767) return;
        if (!$('product-info media-gallery').hasClass('activePopup')) return;
        if (!el.classList.contains('swiper-slide-active')) return;
        e.preventDefault();
        let img = el.querySelector('media-gallery.activePopup .product__media img');
        if (!img) return;
        zoomLevel += e.deltaY < 0 ? 0.1 : -0.1;
        zoomLevel = Math.max(1, Math.min(3, zoomLevel));
        if (zoomLevel === 1) { translateX = 0; translateY = 0; }
        img.style.transform = `scale(${zoomLevel}) translate(${translateX}px, ${translateY}px)`;
        img.style.transformOrigin = 'center center';
    }, { passive: false });
});

$(document).on('touchstart', '.swiper-slide-active', function (e) {
    if (window.innerWidth <= 767) return;
    if (!$('product-info media-gallery').hasClass('activePopup')) return;
    if (e.originalEvent.touches.length === 2) {
        let t1 = e.originalEvent.touches[0];
        let t2 = e.originalEvent.touches[1];
        initialDistance = Math.hypot(t2.pageX - t1.pageX, t2.pageY - t1.pageY);
        initialScale = zoomLevel;
    }
});

$(document).on('touchmove', '.swiper-slide-active', function (e) {
    if (window.innerWidth <= 767) return;
    if (!$('product-info media-gallery').hasClass('activePopup')) return;
    if (e.originalEvent.touches.length === 2 && initialDistance) {
        e.preventDefault();
        let t1 = e.originalEvent.touches[0];
        let t2 = e.originalEvent.touches[1];
        let newDistance = Math.hypot(t2.pageX - t1.pageX, t2.pageY - t1.pageY);
        zoomLevel = initialScale * (newDistance / initialDistance);
        zoomLevel = Math.max(1, Math.min(3, zoomLevel));
        if (zoomLevel === 1) { translateX = 0; translateY = 0; }
        const $img = $(this).find('media-gallery.activePopup .product__media img');
        updateTransform($img);
    }
});

$(document).on('touchend', '.swiper-slide', function (e) {
    if (window.innerWidth <= 767) return;
    if (!$('product-info media-gallery').hasClass('activePopup')) return;
    if (e.originalEvent.touches.length < 2) {
        initialDistance = null;
    }
});

// Accordians Script

$('product-info .customAccordian h3').on('click', function () {
    var $clickedHeader = $(this);
    var $accordion = $clickedHeader.closest('.customAccordian');
    var $content = $accordion.find('.customAccordian-content');
    $('product-info .customAccordian .customAccordian-content').not($content).slideUp(600);
    $('product-info .customAccordian h3').not($clickedHeader).removeClass('active');
    $content.slideToggle(600, function () {
        if ($content.is(':visible')) {
            $clickedHeader.addClass('active');
        } else {
            $clickedHeader.removeClass('active');
        }
    });
});

// Size variant and Popup Script

document.addEventListener('DOMContentLoaded', () => {
    const popupWrapper = document.querySelector('.sizePopupSlide-wrapper');
    const sizeGuideWrapper = document.querySelector('.sizeGuideSlide-wrapper');
    const buyBtnBox = document.querySelector('product-info .customBuyNow .BuyBtnBox');
    const body = document.querySelector('body');

    document.querySelectorAll('span.sizeOption').forEach(el => {
        el.addEventListener('click', () => {
            popupWrapper?.classList.add('active');
            buyBtnBox?.classList.add('active');
            body.classList.add('body-lock-scroll');
        });
    });

    document.querySelector('product-info .customSizeGuide a')?.addEventListener('click', e => {
        e.preventDefault();
        sizeGuideWrapper?.classList.add('active');
        body?.classList.add('body-lock-scroll');
        buyBtnBox?.classList.add('active');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/products/')) {
        if (!sessionStorage.getItem('variantRadioChecked')) {
            const swatchFieldsets = document.querySelectorAll(
                'product-info .product__info-wrapper variant-selects fieldset.product-form__input--swatch'
            );
            swatchFieldsets.forEach(function (fieldset) {
                const firstRadio = fieldset.querySelector('input[type="radio"]');
                if (firstRadio && !firstRadio.checked) {
                    firstRadio.checked = true;

                    firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
            sessionStorage.setItem('variantRadioChecked', 'true');
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const popupWrapper = document.querySelector('.sizePopupSlide-wrapper');
    const popupContent = document.querySelector('.sizePopupSlide-wrapper aside.sizePopupSlide');
    const closeIcon = document.querySelector('.sizePopupSlide-wrapper aside.sizePopupSlide .sizePopupSlideTop .closePopup');
    const sizeOptionLabels = document.querySelectorAll('aside.sizePopupSlide fieldset.sizeOptions label');
    const body = document.querySelector('body');

    // Select all sizeDisplay elements instead of just one
    const sizeDisplays = document.querySelectorAll('product-info .customBuyNow span.sizeOption');

    // Variable to track which sizeDisplay was clicked
    let clickedSizeDisplay = null;

    // Size popup logic
    if (popupWrapper && popupContent) {
        popupWrapper.addEventListener('click', function (event) {
            if (!popupContent.contains(event.target)) {
                popupWrapper.classList.remove('active');
                body.classList.remove('body-lock-scroll');
            }
        });

        if (closeIcon) {
            closeIcon.addEventListener('click', function () {
                popupWrapper.classList.remove('active');
                body.classList.remove('body-lock-scroll');

            });
        }
    }

    // Add click event to all sizeDisplay elements
    sizeDisplays.forEach(function (sizeDisplay) {
        sizeDisplay.addEventListener('click', function () {
            // Store which sizeDisplay was clicked
            clickedSizeDisplay = this;
            // Open popup
            if (popupWrapper) {
                popupWrapper.classList.add('active');
            }
        });
    });

    function updateCartCountBubble() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(data => {
                const count = data.item_count;

                document.querySelectorAll('.cart-count-bubble span').forEach(span => {
                    span.innerText = count;
                    span.parentElement.style.display = count === 0 ? 'none' : 'flex';
                });

                document.querySelectorAll('.cart-count').forEach(span => {
                    span.innerText = count;
                    span.style.display = count === 0 ? 'none' : 'inline-block';
                });

                document.querySelectorAll('.red-dot').forEach(dot => {
                    dot.style.display = count === 0 ? 'none' : 'flex';
                });

                const stickyBtn = document.querySelector('product-info .stickyAddToCart button[type="submit"]');
                if (stickyBtn) {
                    stickyBtn.style.backgroundColor = count === 0 ? '#707070' : '#ce0a2c';
                }
            });
    }
    sizeOptionLabels.forEach(label => {
        label.addEventListener('click', function () {
            const optionValueSpan = label.querySelector('span.optionValue, span.optionValuesoldout');
            const selectedSize = optionValueSpan ? optionValueSpan.innerText.trim() : '';
            const isSoldOut = label.querySelector('span.soldOut');
            const isPreOrder = label.querySelector('span.pre-order');
            document.querySelector('product-info .customBuyNow .BuyBtnBox .sizeOptionPopup')?.remove();

            setTimeout(() => {
                popupWrapper.classList.remove('active');
                body.classList.remove('body-lock-scroll');
                if (clickedSizeDisplay && selectedSize) {
                    const innerSpan = clickedSizeDisplay.querySelector('span');
                    const stickyBtn = document.querySelector('product-info .stickyAddToCart button[type=submit]');
                    const buyBtn = document.querySelector('.customBuyNowContent form button[type="submit"]')
                    const stickyText = stickyBtn.querySelector('span');
                    const buyBtnText = buyBtn?.querySelector('span')
                    const customForm = document.querySelector('product-info .customBuyNow form');

                    stickyBtn.addEventListener('click', function () {
                        document.querySelector('product-info .customBuyNow .BuyBtnBox button[type="submit"]')?.click();
                    });

                    if (innerSpan) {
                        innerSpan.textContent = selectedSize;
                        innerSpan.classList.toggle('sold-out', !!isSoldOut);
                    }

                    if (isPreOrder) {
                        stickyBtn.classList.remove('sold-out');
                        stickyText.textContent = 'PRE ORDER';
                        if (buyBtnText) buyBtnText.textContent = 'PRE ORDER'

                        stickyBtn.style.backgroundColor = '#ce0a2c';
                        stickyBtn.style.pointerEvents = 'all';
                        if (customForm) {
                            const oldInput = customForm.querySelector('input[name="properties[Product]"]');
                            if (oldInput) oldInput.remove();
                            const hiddenInput = document.createElement('input');
                            hiddenInput.type = 'hidden';
                            hiddenInput.name = 'properties[Product]';
                            hiddenInput.value = 'PRE ORDER';
                            customForm.appendChild(hiddenInput);
                        }
                    } else if (isSoldOut) {
                        stickyBtn.classList.add('sold-out');
                        stickyText.textContent = 'Sold Out';
                        stickyBtn.style.backgroundColor = '#707070';
                        stickyBtn.style.pointerEvents = 'none';
                        if (customForm) customForm.querySelector('input[name="properties[Product]"]')?.remove();
                    } else {
                        stickyBtn.classList.remove('sold-out');
                        stickyText.textContent = 'Add to Cart';
                        stickyBtn.style.backgroundColor = '#ce0a2c';
                        stickyBtn.style.pointerEvents = 'all';
                        if (customForm) customForm.querySelector('input[name="properties[Product]"]')?.remove();
                    }
                }

                const buyButtonBox = clickedSizeDisplay ? clickedSizeDisplay.closest('.BuyBtnBox') : null;
                document.querySelector('product-info .customBuyNow .BuyBtnBox span.sizeOption')?.remove();

                if (buyButtonBox && !isSoldOut && !isPreOrder) {
                    const form = document.querySelector('form[action="/cart/add"]');
                    if (form) {
                        const formData = new FormData(form);
                        fetch('/cart/add.js', { method: 'POST', body: formData })
                            .then(() => {
                                document.querySelector('cart-drawer.drawer')?.classList.add('active');
                                fetch('/?section_id=cart-drawer')
                                    .then(res => res.text())
                                    .then(html => {
                                        const doc = new DOMParser().parseFromString(html, 'text/html');
                                        const newDrawer = doc.querySelector('#CartDrawer');
                                        const currentDrawer = document.querySelector('#CartDrawer');
                                        if (newDrawer && currentDrawer) {
                                            currentDrawer.innerHTML = newDrawer.innerHTML;
                                            currentDrawer.querySelector('.is-empty .drawer__header')?.style.setProperty('display', 'flex');
                                            const scroller = currentDrawer.querySelector('.is-empty .drawerScroller');
                                            if (scroller) {
                                                scroller.style.display = 'block';
                                                scroller.style.height = '100%';
                                            }
                                            currentDrawer.querySelector('.is-empty .drawerScroller form#CartDrawer-Form')?.style.setProperty('display', 'flex');
                                        }
                                        updateCartCountBubble();
                                    });
                            });
                    }
                } else if (buyButtonBox && isSoldOut) {
                    const soldOutTextEl = label.querySelector('span.optionValuesoldout');
                    const soldOutText = soldOutTextEl ? soldOutTextEl.innerText.trim() : '';
                    const targetSizeSpan = document.querySelector('product-info .customBuyNow span.sizeOption span');
                    if (targetSizeSpan && soldOutText) {
                        targetSizeSpan.textContent = soldOutText;
                        targetSizeSpan.classList.add('sold-out');
                    }
                }
            }, 1000);
        });
    });
    window.addEventListener('DOMContentLoaded', updateCartCountBubble);

    window.addEventListener('DOMContentLoaded', () => {
        const container = document.querySelector('product-info .customBuyNow .customBuyNowContent');
        const stickyBtn = document.querySelector('product-info .stickyAddToCart button[type=submit]');
        if (stickyBtn && !stickyBtn.querySelector('.sizeOptionPopup')) {
            stickyBtn.style.pointerEvents = 'all';
        }
        const buyBtnBox = container?.querySelector('BuyBtnBox');
        const hasSizeOption = container?.querySelector('div.sizeOption');

        if (buyBtnBox) {
            if (!hasSizeOption) {
                buyBtnBox.style.maxWidth = 'unset';
            }
        }
    });

    // Handle buy button clicks for all BuyBtnBox elements
    const buyButtonBoxes = document.querySelectorAll('product-info .customBuyNow .BuyBtnBox');
    buyButtonBoxes.forEach(function (buyButtonBox) {
        const submitButton = buyButtonBox.querySelector('button[type="submit"]');
        if (submitButton) {
            buyButtonBox.addEventListener('click', function () {
                const sizeDisplay = this.querySelector('span.sizeOption');
                const sizeSpan = sizeDisplay ? sizeDisplay.querySelector('span') : null;

                if (sizeSpan && sizeSpan.innerText.trim() !== 'Size') {
                    submitButton.click();
                }
            });
        }
    });

    // Size guide popup logic
    const guideWrapper = document.querySelector('.sizeGuideSlide-wrapper');
    const guideContent = document.querySelector('.sizeGuideSlide-wrapper aside.sizeGuideSlide');
    const guideCloseIcon = document.querySelector('.sizeGuideSlide-wrapper aside.sizeGuideSlide .sizeGuideSlideTop svg');


    if (guideWrapper && guideContent) {
        guideWrapper.addEventListener('click', function (event) {
            if (!guideContent.contains(event.target)) {
                guideWrapper.classList.remove('active');
            }
        });

        if (guideCloseIcon) {
            guideCloseIcon.addEventListener('click', function () {
                guideWrapper.classList.remove('active');
                body.classList.remove('body-lock-scroll');
            });
        }
    }
});

$(document).on('click', 'product-info .product__info-wrapper variant-selects fieldset.product-form__input--swatch label', function () {
    var radio = $(this).prev('input[type="radio"]');
    if (radio.length) {
        localStorage.setItem('checkedRadio', radio.attr('id'));
    }
    setTimeout(function () {
        location.reload();
    }, 1000);
});

$(document).ready(function () {
    var savedRadioId = localStorage.getItem('checkedRadio');
    if (savedRadioId) {
        $('#' + savedRadioId).prop('checked', true);
        localStorage.removeItem('checkedRadio');
    }
});

// Download Button Script

async function downloadFile(event, element) {
    event.preventDefault(); // Stop the default anchor behavior

    const fileUrl = element.getAttribute('href');
    const fileName = element.getAttribute('data-fileName') || 'downloaded_file';

    try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();

        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(downloadLink);
    } catch (error) {
        console.error('Download failed:', error);
        alert('Download failed!');
    }
}

// Sticky Add To Cart Button

const target = document.querySelector('product-info .product__info-wrapper .customBuyNow');
const sticky = document.querySelector('product-info .stickyAddToCart');

window.addEventListener('scroll', function () {
    if (target) {
        const targetBottom = target.getBoundingClientRect().bottom;

        if (targetBottom < 0) {
            sticky.classList.add('active');
        } else {
            sticky.classList.remove('active');
        }
    }
});

// Estimated Delivery Date Script

$(document).ready(function () {
    $('.estimatedDelivery').each(function () {
        const days = parseInt($(this).data('after-days'))
        const futureDate = new Date()
        futureDate.setDate(futureDate.getDate() + days)

        const options = { month: 'long', day: 'numeric' }
        const formattedDate = futureDate.toLocaleDateString('en-US', options)

        const day = futureDate.getDate()
        let suffix = 'th'
        if (day % 10 == 1 && day != 11) suffix = 'st'
        else if (day % 10 == 2 && day != 12) suffix = 'nd'
        else if (day % 10 == 3 && day != 13) suffix = 'rd'

        $(this).find('strong').text(`${formattedDate}${suffix}`)
    })
})

$(document).ready(function () {
    $('.swatch-img').each(function () {
        const $img = $(this);
        const $loader = $img.siblings('.cl-swatch-loader');

        if ($img[0].complete) {
            $loader.hide();
            $img.css('opacity', 1);
        } else {
            $img.on('load', function () {
                $loader.fadeOut(200);
                $img.css('opacity', 1);
            }).on('error', function () {
                $loader.hide();
            });
        }
    });
});

$(document).on('click', '.sizeOptionPopup', function () {
    $('.sizePopupSlide-wrapper').addClass('active');
    $('body').addClass('pdp-size');
});
$(document).on('click', 'aside.sizePopupSlide fieldset.sizeOptions label', function () {
    if (!$('body').hasClass('pdp-size')) return;

    var isSoldOut = $(this).find('.soldOut').length > 0;
    var isPreOrder = $(this).find('.pre-order').length > 0;
    var soldText = $(this).find('.optionValuesoldout').text().trim();
    var normalText = $(this).find('.optionValue').text().trim();
    var targetSpan = $('product-info .customBuyNow span.sizeOption span');
    var stickyBtn = $('product-info .stickyAddToCart button[type=submit]');
    var buyBtn = $('.customBuyNowContent form button[type="submit"]');
    var stickyBtnSpan = stickyBtn.find('span');
    var customForm = $('product-info .customBuyNow form');

    if (isPreOrder) {
        stickyBtnSpan.text('PRE ORDER');
        customForm.find('input[name="properties[Product]"]').remove();
        customForm.append('<input type="hidden" name="properties[Product]" value="PRE ORDER">');
        setTimeout(() => {
            buyBtn.find('span').text('PRE ORDER')
        }, 3000);
    } else if (isSoldOut) {
        targetSpan.text(soldText).addClass('sold-out');
        stickyBtn.addClass('active');
        stickyBtnSpan.text('Sold Out');
    } else {
        targetSpan.text(normalText).removeClass('sold-out');
        stickyBtn.removeClass('active');
        stickyBtnSpan.text('ADD TO BAG');
        customForm.find('input[name="properties[Product]"]').remove();
    }

    $('body').removeClass('pdp-size');
    stickyBtn.css('pointer-events', 'all');
    setTimeout(() => {
        $('product-info .customBuyNow .BuyBtnBox button[type=submit]').click();
    }, 1000);
});
$(document).on('click', 'product-info .stickyAddToCart button[type=submit]', function () {
    if (!$(this).find('.sizeOptionPopup').length) {
        setTimeout(() => {
            $('product-info .customBuyNow .BuyBtnBox button[type=submit]').click();
        }, 1000);
    }
});